import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const issuesContent = EntityContentBlueprint.make({
  name: 'issues',
  params: {
    path: 'github-issues',
    title: 'GitHub Issues',
    loader: async () => {
      const { GithubView } = await import('./views/GithubView');
      return <GithubView kind="issues" />;
    },
  },
});
const pullRequestsContent = EntityContentBlueprint.make({
  name: 'pull-requests',
  params: {
    path: 'pull-requests',
    title: 'Pull Requests',
    loader: async () => {
      const { GithubView } = await import('./views/GithubView');
      return <GithubView kind="pull-requests" />;
    },
  },
});
export const rdapGithubPlugin = createFrontendPlugin({
  pluginId: 'rdap-github',
  extensions: [issuesContent, pullRequestsContent],
});
